import { render, staticRenderFns } from "./PosDebtBalancePayBank.vue?vue&type=template&id=4f23116f&scoped=true&"
import script from "./PosDebtBalancePayBank.vue?vue&type=script&lang=js&"
export * from "./PosDebtBalancePayBank.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f23116f",
  null
  
)

export default component.exports